import { useDebouncedValue } from "@mantine/hooks";
import type { FC } from "react";

import { useClientManager } from "@megaron/react-clients";

import { SupportTicketOrderTile } from "./SupportTicketOrderTile";

type Props = {
  invoiceNumber: string;
  orderNumber: string;
};

export const SupportTicketLinkedInvoice: FC<Props> = ({ invoiceNumber, orderNumber }) => {
  const trimmedInvoiceNumber = invoiceNumber.trim();
  const trimmedOrderNumber = orderNumber.trim();
  const [debouncedInvoiceNumber] = useDebouncedValue(trimmedInvoiceNumber, 300);
  const docs = useClientManager("docs");
  const ordersQuery = docs.searchOrders().useQuery(
    { searchText: debouncedInvoiceNumber, limit: 20 },
    { enabled: debouncedInvoiceNumber.length > 0 },
  );
  const match = (ordersQuery.data?.items ?? []).find((order) =>
    order.invoiceNumbers.some((invoice) => invoice.trim() === debouncedInvoiceNumber),
  );

  if (!match || match.number === trimmedOrderNumber) {
    return null;
  }

  return <SupportTicketOrderTile orderNumber={match.number} sellToName={match.sellToName} />;
};
